import React from 'react';
import styled from 'styled-components';

const Legend = styled.div`
    color: var(--primary);
    font-size: 0.9rem;
    line-height: 1.3;
    margin: var(--pad-y) 0;
`;

const CinemaMaintenanceLegend = ({ text }: { text: string }) => (
    <Legend>
        ⚠️ <em>{text}</em>
    </Legend>
);

export default CinemaMaintenanceLegend;